import React from 'react';

import { IDocument } from './interface';

const Document: React.FC<IDocument> = (props) => {
  const { type, value } = props;

  let parsed = '';

  switch (type) {
    case 'cnpj':
      parsed = value.replace(
        /^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/g,
        '$1.$2.$3/$4-$5'
      );
      break;
    case 'cpf':
      parsed = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
      break;
    default:
      break;
  }

  return <>{parsed}</>;
};

export const DocumentStr = (props: IDocument) => {
  const { type, value } = props;

  if (!value) return '';

  let parsed = '';

  switch (type) {
    case 'cnpj':
      parsed = value.slice(0, 18);
      parsed = parsed.replace(/[^0-9A-Za-z]/g, '');
      parsed = parsed.replace(
        /^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/g,
        '$1.$2.$3/$4-$5'
      );
      break;
    case 'cpf':
      parsed = value.slice(0, 14);
      parsed = parsed.replace(/[^0-9]/g, '');
      parsed = parsed.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
      break;
    default:
      break;
  }

  return parsed;
};


export function formatDocument(cpfCnpj: string) {
  cpfCnpj = cpfCnpj?.replace(/[^0-9A-Za-z.-]/g, '');
  cpfCnpj = cpfCnpj?.replace(/[\(\)\.\s-]+/g, '');
  cpfCnpj = cpfCnpj?.slice(0, 14);

  if (cpfCnpj?.length < 10) {
    cpfCnpj = cpfCnpj?.replace(/\D/g, "");
  } else if (cpfCnpj?.length >= 10 && cpfCnpj?.length <= 11) {
    cpfCnpj = cpfCnpj?.replace(/[^0-9]/g, '');

    cpfCnpj = cpfCnpj?.replace(/(\d{3})(\d)/, "$1.$2");

    cpfCnpj = cpfCnpj?.replace(/(\d{3})(\d)/, "$1.$2");

    cpfCnpj = cpfCnpj.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    cpfCnpj = cpfCnpj?.replace(/^([0-9A-Za-z]{2})([0-9A-Za-z])/, "$1.$2");

    cpfCnpj = cpfCnpj?.replace(/^([0-9A-Za-z]{2})\.([0-9A-Za-z]{3})([0-9A-Za-z])/, "$1.$2.$3");

    cpfCnpj = cpfCnpj?.replace(/\.([0-9A-Za-z]{3})([0-9A-Za-z])/, ".$1/$2");

    cpfCnpj = cpfCnpj?.replace(/([0-9A-Za-z]{4})(\d)/, "$1-$2");
  }

  return cpfCnpj;
}

export const DocumentDigits = (document: any) =>
  document.match(/\d+/g)?.join('');


export const ValidateCpf = (cpf: string) => {
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }

  let numero: number = 0;
  let caracter: string = '';
  const numeros: string = '0123456789';
  let j: number = 10;
  let somatorio: number = 0;
  let resto: number = 0;
  let digito1: number = 0;
  let digito2: number = 0;
  let cpfAux: string = '';

  cpfAux = cpf.substring(0, 9);

  for (let i: number = 0; i < 9; i++) {
    caracter = cpfAux.charAt(i);
    if (numeros.search(caracter) === -1) {
      return false;
    }
    numero = Number(caracter);
    somatorio += numero * j;
    j--;
  }

  resto = somatorio % 11;
  digito1 = 11 - resto;
  if (digito1 > 9) {
    digito1 = 0;
  }
  j = 11;
  somatorio = 0;
  cpfAux += digito1;

  for (let i: number = 0; i < 10; i++) {
    caracter = cpfAux.charAt(i);
    numero = Number(caracter);
    somatorio += numero * j;
    j--;
  }
  resto = somatorio % 11;
  digito2 = 11 - resto;

  if (digito2 > 9) {
    digito2 = 0;
  }
  cpfAux += digito2;

  if (cpf !== cpfAux) {
    return false;
  }

  return true;
};

export default Document;
